import { isArray, isEmpty, isNumber } from 'lodash';
const regCron = /(.*)\s(.*)\s(.*)\s(.*)\s(.*)\s(.*)/;

function isValidExpresion(cron: string): boolean {
    return !isEmpty(cron) && cron.match(/\s/g).length === 5 && new RegExp(regCron).test(cron);
}

function validateExpresion(cron: string): void {
    if (!isValidExpresion(cron))
        throw new Error('Invalid cron Exp!!!');
}

function getGroupFromRegex(cron: string, x: number): string {
    const match = regCron.exec(cron);
    return match[x + 1];
}

export function isDaily(cron: string): boolean {
    validateExpresion(cron);
    return isNumber(getSeconds(cron)) &&
        isNumber(getMinutes(cron)) &&
        isNumber(getHour(cron)) &&
        getGroupFromRegex(cron, 3) === '*' &&
        getGroupFromRegex(cron, 4) === '*' &&
        getGroupFromRegex(cron, 5) === '*';
}

export function isWeakly(cron: string): boolean {
    validateExpresion(cron);
    return isNumber(getSeconds(cron)) &&
        isNumber(getMinutes(cron)) &&
        isNumber(getHour(cron)) &&
        getGroupFromRegex(cron, 3) === '*' &&
        getGroupFromRegex(cron, 4) === '*' &&
        isArray(getWeekDays(cron));
}

export function isMonthly(cron: string): boolean {
    validateExpresion(cron);
    return isNumber(getSeconds(cron)) &&
        isNumber(getMinutes(cron)) &&
        isNumber(getHour(cron)) &&
        isArray(getMonthDays(cron)) &&
        getGroupFromRegex(cron, 4) === '*' &&
        getGroupFromRegex(cron, 5) === '*';
}

export function getSeconds(cron: string): string | number {
    validateExpresion(cron);
    const value = getGroupFromRegex(cron, 0);
    return !isNaN(parseInt(value)) ? parseInt(value) : value;
}

export function getMinutes(cron: string): string | number {
    validateExpresion(cron);
    const value = getGroupFromRegex(cron, 1);
    return !isNaN(parseInt(value)) ? parseInt(value) : value;
}

export function getHour(cron: string): string | number {
    validateExpresion(cron);
    const value = getGroupFromRegex(cron, 2);
    return !isNaN(parseInt(value)) ? parseInt(value) : value;
}

export function getWeekDays(cron: string): string | number[] {
    validateExpresion(cron);
    const value = getGroupFromRegex(cron, 5);
    return value === '*' ? value : value.split(',').map(v => parseInt(v));
}

export function getMonthDays(cron: string): string | number[] {
    validateExpresion(cron);
    const value = getGroupFromRegex(cron, 3);
    return value === '*' ? value : value.split(',').map(v => parseInt(v));
}
